/* eslint-disable no-sequences */
/* eslint-disable camelcase */
// eslint-disable-next-line camelcase
let
  javaBase_url,
  host_url,
  erp_url,
  base_urlpinbuy,
  front_pinbuy_url,
  erp_api_url,
  api_url,
  japi_url,
  api_liveadminUrl,
  m_main_url,
  m_cart_url,
  m_live_url,
  m_user_url,
  pc_main_url,
  pc_cart_url,
  pc_user_url,
  backend_url,
  backend2_url,
  webadmin_url,
  oms_admin_url,
  oms2_api_url,
  image_url,
  admin_url,
  commonUrl,
  o2o_url,
  qiniu_url,
  api_net_to_java,
  static_url
let _env = process.env.REACT_APP_ENV === 'test' ? 'test' : process.env.REACT_APP_ENV === 'production' ? 'production' : 'development'
switch (_env) {
  case 'development' : // 开发环境
    javaBase_url = 'https://ppsq-t.vsigo.cn/'
    host_url = 'http://localhost:3000/'
    erp_url = 'http://eureka.t.vsigo.cn/'
    erp_api_url = 'http://erpapi-t.vsigo.cn/'
    api_net_to_java = 'https://gw-admin-t.vsigo.cn/webadmin/'
    api_url = 'https://api-t.vsigo.cn/'
    japi_url = 'https://japi-t.vsigo.cn/'
    m_main_url = 'https://m-t.vsigo.cn/'
    m_cart_url = 'https://cart-m-t.vsigo.cn/'
    m_live_url = 'https://live-m-t.vsigo.cn/'
    m_user_url = 'https://my-m-t.vsigo.cn/'
    pc_main_url = 'https://www-t.vsigo.cn/'
    pc_cart_url = 'https://cart-t.vsigo.cn/'
    pc_user_url = 'https://my-t.vsigo.cn/'
    backend_url = 'http://backend.t.vsigo.cn/'
    backend2_url = 'http://backend2.vsigo.cn/'
    webadmin_url = 'https://webadmin.t.vsigo.cn/'
    oms_admin_url = 'http://oms-t.vsigo.cn/'
    oms2_api_url = 'http://erp-all-gateway-inc-t.seeke.net/'
    image_url = 'https://images-t.vsigo.cn/'
    admin_url = 'https://b2cadmin-t.vsigo.cn/'
    commonUrl = 'https://api-t.njtuling.com/'
    o2o_url = 'https://admino2o-t.vsigo.cn/'
    base_urlpinbuy = 'https://gw-admin-t.vsigo.cn/pinbuy/'
    front_pinbuy_url = 'https://api-pinbuy-t.vsigo.cn/'
    api_liveadminUrl = 'https://gw-admin-t.vsigo.cn/live/'
    qiniu_url = 'http://videos.vsigo.cn/'
    static_url = 'https://api_t.yjq.com/main/anyms/file/upload/pic/sync'
    break
  case 'test' : // 测试环境 ppsq-t.vsigo.cn/
    javaBase_url = 'https://ppsq-t.vsigo.cn/'
    host_url = 'http://b2cadmin-t.vsigo.cn/'
    erp_url = 'http://eureka.t.vsigo.cn/'
    erp_api_url = 'http://erpapi-t.vsigo.cn/'
    api_net_to_java = 'https://gw-admin-t.vsigo.cn/webadmin/'
    api_url = 'https://api-t.vsigo.cn/'
    japi_url = 'https://japi-t.vsigo.cn/'
    m_main_url = 'https://m-t.vsigo.cn/'
    m_cart_url = 'https://cart-m-t.vsigo.cn/'
    m_live_url = 'https://live-m-t.vsigo.cn/'
    m_user_url = 'https://my-m-t.vsigo.cn/'
    pc_main_url = 'https://www-t.vsigo.cn/'
    pc_cart_url = 'https://cart-t.vsigo.cn/'
    pc_user_url = 'https://my-t.vsigo.cn/'
    backend_url = 'http://backend.t.vsigo.cn/'
    backend2_url = 'http://backend2.vsigo.cn/'
    webadmin_url = 'https://webadmin.t.vsigo.cn/'
    oms_admin_url = 'http://oms-t.vsigo.cn/'
    oms2_api_url = 'http://erp-all-gateway-inc-t.seeke.net/'
    image_url = 'https://images-t.vsigo.cn/'
    admin_url = 'https://b2cadmin-t.vsigo.cn/'
    commonUrl = 'https://api-t.njtuling.com/'
    o2o_url = 'https://admino2o-t.vsigo.cn/'
    base_urlpinbuy = 'https://gw-admin-t.vsigo.cn/pinbuy/'
    front_pinbuy_url = 'https://api-pinbuy-t.vsigo.cn/'
    api_liveadminUrl = 'https://gw-admin-t.vsigo.cn/live/'
    qiniu_url = 'http://videos.vsigo.cn/'
    static_url = 'https://api_t.yjq.com/main/anyms/file/upload/pic/sync'
    break
  case 'production' : // 线上地址
    javaBase_url = 'https://ppsq.vsigo.cn/'
    host_url = 'http://b2cadmin.vsigo.cn/'
    erp_url = 'http://eureka.vsigo.cn/'
    erp_api_url = 'http://erpapi.vsigo.cn/'
    api_net_to_java = 'https://gw-admin.vsigo.cn/webadmin/'
    api_url = 'https://api.vsigo.cn/'
    japi_url = 'https://japi.vsigo.cn/'
    m_main_url = 'https://m.vsigo.cn/'
    m_cart_url = 'https://cart.m.vsigo.cn/'
    m_live_url = 'https://live.m.vsigo.cn/'
    m_user_url = 'https://my.m.vsigo.cn/'
    pc_main_url = 'https://www.vsigo.cn/'
    pc_cart_url = 'https://cart.vsigo.cn/'
    pc_user_url = 'https://my.vsigo.cn/'
    backend_url = 'http://backend.vsigo.cn/'
    backend2_url = 'http://backend2.vsigo.cn/'
    webadmin_url = 'https://webadmin.vsigo.cn/'
    oms_admin_url = 'http://oms.vsigo.cn/'
    oms2_api_url = 'http://erp-all-gateway-inc-p.seeke.net/'
    image_url = 'https://images.vsigo.cn/'
    admin_url = 'https://b2cadmin.vsigo.cn/'
    commonUrl = 'https://api.njtuling.com/'
    o2o_url = 'https://admino2o.vsigo.cn/'
    base_urlpinbuy = 'https://gw-admin.vsigo.cn/pinbuy/'
    front_pinbuy_url = 'https://api-pinbuy.vsigo.cn/'
    api_liveadminUrl = 'https://gw-admin.vsigo.cn/live/'
    qiniu_url = 'http://videos.vsigo.cn/'
    static_url = 'https://api.yjq.com/main/anyms/file/upload/pic/sync'
    break
}
export default {
  m_main_url,
  m_cart_url,
  m_live_url,
  m_user_url,
  pc_main_url,
  pc_cart_url,
  pc_user_url,
  backend_url,
  backend2_url,
  webadmin_url,
  oms_admin_url,
  oms2_api_url,
  image_url,
  admin_url,
  erp_api_url,
  api_url,
  japi_url,
  static_url,
  'host_url': host_url,
  'base_urlpinbuy': base_urlpinbuy, // pinbuy接口
  front_pinbuy_url,
  'base_urlcomment': javaBase_url,
  'old_api': api_url,
  'new_net_to_java': api_net_to_java,
  'test_url': api_liveadminUrl,
  'commonUrl': commonUrl,
  'javaBase_url': javaBase_url,
  'qiniu_video': qiniu_url,
  'erp_url': erp_url,
  'o2o_url': o2o_url,
  'mina_url': 'http://sigo-mina-1goiug8665d844e1-1304819408.tcloudbaseapp.com',
  'noLoginToken': '2B73C1A9955B4A5E27DEFCB2A51AF08B', // 嵌套第三方系统 项目不登录调用接口使用的token
  'route-data': [
    [
      {
        name: '订单',
        urlArray: [
          {
            value: '首页',
            url: '/main/order/index'
          },
          {
            value: '订单统计',
            url: '/main/order/analysis'
          },
          {
            value: '订单列表',
            url: '/main/order/list'
          },
          {
            value: '缺货订单',
            url: '/main/order/outofstocklist'
          },
          {
            value: '取消订单',
            url: '/main/order/cancellist'
          }
        ]
      }
    ],
    [
      {
        name: '推广会员',
        urlArray: [
          {
            value: '推广会员首页',
            url: '/main/marketinguser/index'
          },
          {
            value: '推广会员列表',
            url: '/main/marketinguser/list'
          }
        ]
      }
    ],
    [
      {
        name: '会员',
        urlArray: [
          {
            value: '会员首页',
            url: '/main/user/index'
          },
          {
            value: '会员列表',
            url: '/main/user/list'
          }
        ]
      }
    ],
    [
      {
        name: '营销',
        urlArray: [
          {
            value: '金币商城首页',
            url: '/main/marketing/goldstore/gold-store'
          }
        ]
      }
    ]
  ]
}



// WEBPACK FOOTER //
// ./src/public/common.js